import { useMemo } from 'react';
import { numberUtil } from '@goodfynd/react-web.lib.utils';
import { Text } from '@goodfynd/react-web.typography.text';
import { Modal } from '@goodfynd/react-web.ui.modal';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import { StyledContainer } from './styles';
import type { EventCommissionExampleModalProps } from './types';
export function EventCommissionExampleModal({
  orderingFee = 10,
  posFee = 0,
  price = 10,
  ...props
}: EventCommissionExampleModalProps) {
  const defaultPosCommission = useMemo(() => {
    return numberUtil.asCurrency(price * 0.0245 + 0.05);
  }, [price]);

  const [onlineCommission, onlineCommissionPercentage] = useMemo(() => {
    const percentage = numberUtil.asCurrency(orderingFee / 100);
    const commission = numberUtil.asCurrency(price * percentage);
    return [commission, percentage];
  }, [orderingFee, price]);

  const [posCommission, posCommissionPercentage] = useMemo(() => {
    const percentage = numberUtil.asCurrency(posFee / 100);
    const commission = numberUtil.asCurrency(price * percentage);
    return [commission, percentage];
  }, [posFee, price]);

  return (
    <Modal
      aria-describedby="profiles-switching"
      aria-labelledby="profiles-modal"
      closeButtonCss={{
        background: 'none',
        boxShadow: 'none',
      }}
      header={
        <Text as="h2" type="h5">
          Goodfynd Event Commission
        </Text>
      }
      {...props}
    >
      <StyledContainer>
        <Text>
          Below is an example of how commission will be calculated based on
          event service fees.
        </Text>

        <Table
          sx={{
            borderRadius: 0,
            marginTop: 4,
            td: { border: '1px solid gray', borderCollapse: 'collapse' },
          }}
        >
          <TableBody>
            <TableRow>
              <TableCell>
                <Text>Product Price (no tax)</Text>
              </TableCell>
              <TableCell>
                <Text>{numberUtil.renderPrice(price)}</Text>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <Text>Online %</Text>
              </TableCell>
              <TableCell>
                <Text>
                  {numberUtil.renderPercent(onlineCommissionPercentage)}
                </Text>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <Text>POS %</Text>
              </TableCell>
              <TableCell>
                <Text>
                  {posCommissionPercentage
                    ? `${numberUtil.renderPercent(
                        posCommissionPercentage
                      )} + 2.45% + $0.05`
                    : '2.45% + $0.05'}
                </Text>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <Text>Vendor Online Fee</Text>
              </TableCell>
              <TableCell>
                <Text>{numberUtil.renderPrice(onlineCommission)}</Text>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <Text>Vendor POS Fee</Text>
              </TableCell>
              <TableCell>
                <Text>
                  {numberUtil.renderPrice(posCommission + defaultPosCommission)}
                </Text>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </StyledContainer>
    </Modal>
  );
}
